export const checkRoles = (userRolesIds: string[], checkRoles: string[]) => {
  return userRolesIds.some((userRole) => checkRoles?.includes(userRole))
}
